module.exports = __webpack_public_path__ + "img/item-header.7b138fd8.png";